(function recommendedCommunitiesDesktopPaid() {
    'use strict';

    let brochureBlobUrl = null;
    let leadActionBtn = null;

    function lazyLoadCss() {
        const bundle = document.getElementById('detailsXpRecosCss').value;

        if (bundle && window.NHS && window.NHS.loadCss) {
            window.NHS.loadCss(bundle);
        }
    }

    /**
     * Submits the recommended communities lead data to the server.
     * @param {Object} command - The command object containing the lead data.
     */
    async function submitRecommendedCommunitiesLead(command) {
        // we use a shoot and forget request to send the recommended lead data to the server
        const response = await fetch('/ajax/leads/recommendedcommunitysubmission/', {
            method: 'POST',
            body: JSON.stringify({
                ...command,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        });

        // append the trackers to the DOM to trigger analytics events, segment event and trackers.
        const trackers = await response.text();

        const container = document.querySelector('[data-trackers-container]');
        if (container) {
            const fragment = document.createRange().createContextualFragment(trackers);
            container.innerHTML = '';
            container.appendChild(fragment);
            container.style.display = 'none';
        }
    }

    /**
     * Gets an array with the recommended communities information selected by the user.
     * @param {Object} formData with the form inputs to be submited.
     */
    function getSelectedRecommendedCommunities() {
        return Array.from(document.querySelectorAll('[data-recommendation-check]'))
            .filter((recommendation) => recommendation.checked)
            .map((recommendation) => JSON.parse(recommendation.value));
    }

    /**
     *
     * Validates if there's at least 1 recommendation selected. If that's not the case,
     * disables the brochure button.
     */
    function onRecommendationChecked() {
        const submitButton = document.querySelector('[data-recommended-button]');
        const checkedRecos = document.querySelectorAll('[data-recommendation-check]:checked');
        if (checkedRecos.length === 0) {
            submitButton.disabled = true;
            return;
        }

        submitButton.disabled = false;
    }

    /**
     * Returns the lead type based on the provided planId and SpecId.
     * If either SpecId or planId is provided, it returns 'postHomeBrochure'.
     * Otherwise, it returns 'postCommunityBrochure'.
     *
     * @param {string} planId - The plan ID.
     * @param {string} SpecId - The Spec ID.
     * @returns {string} The lead type.
     */
    function getLeadType(planId, SpecId) {
        if (Number(SpecId) || Number(planId)) {
            return 'postHomeBrochure';
        }

        return 'postCommunityBrochure';
    }

    /**
     * Returns a command object to be used to get the recommended communities.
     * @param {FormData} data - The form data containing the necessary fields.
     * @returns {Object} - The recommended command object.
     */
    function getRecommendedCommunitiesSubmissionCommand(data) {
        const name = data.Name || '';
        const firstName = name.split(' ')[0] || '';
        const lastName = name.split(' ')[1] || '';
        const recoComms = getSelectedRecommendedCommunities();

        return {
            CommunityId: data.CommunityId,
            FromPage: data.FromPage,
            Zip: data.ZipCode || data.UserPostalCode,
            Phone: data.UserPhoneNumber || data.Phone,
            BuilderId: data.BuilderId,
            Email: data.MailAddress || data.email || '',
            MarketId: data.MarketId,
            Type: getLeadType(data.PlanId, data.SpecId),
            FirstName: firstName,
            LastName: lastName,
            RecoComms: recoComms,
            Guid: window.NewHomeSource.GuidGenerator.leadGuid,
        };
    }

    /**
     * Returns a command object to be used to submit the skip action.
     * @param {FormData} data - The form data containing the necessary fields.
     * @returns {Object} - The recommended command object.
     */
    function getSkipSubmissionCommand(data) {
        const name = data.Name || '';
        const firstName = name.split(' ')[0] || '';
        const lastName = name.split(' ')[1] || '';
        const recoComms = [];

        return {
            CommunityId: data.CommunityId,
            FromPage: data.FromPage,
            Zip: data.ZipCode,
            Phone: data.UserPhoneNumber,
            BuilderId: data.BuilderId,
            Email: data.MailAddress || data.email || '',
            MarketId: data.MarketId,
            Type: getLeadType(data.PlanId, data.SpecId),
            FirstName: firstName,
            LastName: lastName,
            RecoComms: recoComms,
        };
    }

    /**
     * Toggles the visibility of a modal element by adding or removing the 'hidden' attribute.
     * @param {HTMLElement} modal - The modal element to toggle.
     */
    function toggleModal(modal) {
        modal.toggleAttribute('hidden');
    }

    /**
     * Clears previous modals and performs additional actions.
     */
    function clearPreviousModals() {
        const previousModals = document.querySelectorAll('#modal-content');
        const previousBackgrounds = document.querySelectorAll('#modal');

        previousModals.forEach((modal) => {
            modal.remove();
        });

        previousBackgrounds.forEach((background) => {
            background.remove();
        });

        if (window.NewHomeSource.FullImageViewer && window.NewHomeSource.FullImageViewer.MoreInfoPanel) {
            window.NewHomeSource.FullImageViewer.MoreInfoPanel.closePanelActions();
        }
    }


    /**
     * Displays a "Thank You" modal by dispatching a custom event with the provided details.
     *
     * @param {string} pdfBrochureUrl - The URL of the PDF brochure to be displayed or downloaded.
     * @param {string} ListingName - The name of the listing associated with the modal.
     * @param {Blob|null} [pdfBrochureBlob=null] - An optional Blob object representing the PDF brochure.
     */
    function displayThankYouModal(pdfBrochureUrl, ListingName) {
        document.body.dispatchEvent(new CustomEvent('showPaidThankYouModal', {
            detail: {
                pdfBrochureUrl: pdfBrochureUrl || null,
                listingName: ListingName,
                pdfBrochureBlob: brochureBlobUrl,
                leadActionBtn: leadActionBtn
            }
        }));
    }

    /**
     * Shows the recommendations modal.
     * @param {string} recommended - The recommended content to display in the modal.
     */
    function showRecomendationsModal(recommended, data) {
        const templateElement = document.querySelector('[data-recommendations-template]');
        const template = document.createRange().createContextualFragment(templateElement.innerHTML);

        clearPreviousModals();

        if (window.NewHomeSource.ModalLoader) {
            window.NewHomeSource.ModalLoader.createModal(template);
        }

        const recommendationsModal = document.getElementById('nhs_ModalRecommendations');

        const legalTextElement = recommendationsModal.querySelector('[data-legal-text]');
        if (legalTextElement) {
          // this function is declared in GlobalResourcesMvc/Default/js/LeadForm/LeadForm.common.js
          // and available here because that other file is bundled with this file.
          setupShowMoreLegalText(legalTextElement);
        }

        if (recommended !== '') {
            const container = recommendationsModal.querySelector('.recommendations__container');

            recommendationsModal.removeAttribute('hidden');
            container.innerHTML = recommended;

            const ga4Event = {
                eventName: 'direc_section_view',
                eventType: 'GA4Event',
                params: {
                    position: data.GenerateLeadFrom,
                    button_name: data.ButtonNameSource,
                }
            };

            document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
                detail: {
                    data: ga4Event,
                }
            }));
        } else {
            // hide the recommendations modal
            toggleModal(recommendationsModal);

            // emit a custom event to show the thank you modal
            (async function fetchBrochureUrl() {
                const listingInfo = getListingInfo(data);
                const pdfBrochureUrl = await getPdfBrochureUrl(listingInfo, data.DisableBrochure);

                displayThankYouModal(pdfBrochureUrl, data.ListingName);
            })();

            const command = getRecommendedCommunitiesSubmissionCommand(data);
            submitRecommendedCommunitiesLead(command);
        }
    }

    /**
     * Retrieves the recommended communities command based on the provided data.
     * @param {Object} data - The data object containing the necessary properties.
     * @param {string} data.SpecId - The ID of the specification.
     * @param {string} data.PlanId - The ID of the plan.
     * @param {string} data.CommunityId - The ID of the community.
     * @param {string} data.MailAddress - The email address.
     * @returns {Object} - The recommended communities command object.
     */
    function getRecommendedCommunitiesCommand(data) {
        const {
          SpecId,
          PlanId,
          CommunityId,
          MailAddress,
          Name,
          UserPostalCode,
          WasMatchedAsSpotlightResult,
          SpotlightResultPosition,
          MarketId
        } = data;
        return {
            CommunityId,
            PlanId,
            SpecId,
            MailAddress,
            Name,
            UserPostalCode,
            Type: getLeadType(PlanId, SpecId),
            WasMatchedAsSpotlightResult,
            SpotlightResultPosition,
            MarketId
        };
    }

    /**
     * Retrieves recommended communities based on the provided data.
     * @param {Object} data - The data used to generate the recommended communities.
     * @returns {Promise<string>} - A promise that resolves with the recommended communities.
     */
    async function getRecommendedCommunities(data) {
        const recommendedCommand = getRecommendedCommunitiesCommand(data);

        const recommended = await fetch('/ajax/leads/getrecommendedcommunities', {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({
                leadCommand: recommendedCommand,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((response) => response.text());

        return recommended;
    }

    function skipRecommendation(pdfBrochureUrl, data) {
        const recommendationsModal = document.querySelector('[data-recommendations-modal]');
        const command = getSkipSubmissionCommand(data);

        // hide the recommendations modal
        toggleModal(recommendationsModal);

        // emit a custom event to show the thank you modal
        displayThankYouModal(pdfBrochureUrl, data.ListingName);

        submitRecommendedCommunitiesLead(command);
    }

    /**
     * Attaches event listeners to the recommendations modal.
     * @function
     * @returns {void}
     */
    async function skipButtonClickHandler() {
        skipRecommendation(this.pdfBrochureUrl, this.data);
    }

    /**
     * Attaches event listeners to the recommendations modal.
     * @function
     * @returns {void}
     */
    async function submitButtonClickHandler() {
        const recommendationsModal = document.querySelector('[data-recommendations-modal]');
        const command = getRecommendedCommunitiesSubmissionCommand(this.data);

        // hide the recommendations modal
        toggleModal(recommendationsModal);

        // emit a custom event to show the thank you modal
        displayThankYouModal(this.pdfBrochureUrl, this.data.ListingName);
        submitRecommendedCommunitiesLead(command);
    }

    /**
     * Asynchronously fetches the PDF brochure URL for the given listing information
     * if the brochure feature is enabled.
     *
     * @async
     * @function getPdfBrochureUrl
     * @param {Object} listingInfo - An object containing information about the listing.
     * @param {boolean} disabledBrochure - A flag indicating whether the brochure feature is disabled.
     * @returns {Promise<string|null>} - A promise that resolves to the PDF brochure URL, or null if disabled.
     */
    async function getPdfBrochureUrl(listingInfo, disabledBrochure) {
        const isDisabled = !disabledBrochure || String(disabledBrochure).toLowerCase() === 'true';
        if (isDisabled) return null;
        return await window.NewHomeSource.BrochureHandler.getPdfBrochureUrl(listingInfo);
    }

    /**
     * Extracts listing information from the provided data object.
     * @function getListingInfo
     * @param {Object} data - The data object containing listing details.
     * @param {string} data.CommunityId - The community ID of the listing.
     * @param {boolean} data.IsPlan - Indicates whether the listing is a plan.
     * @param {boolean} data.IsMPCommunity - Indicates whether the listing is part of a master-planned community.
     * @param {string} data.PlanId - The ID of the plan (if applicable).
     * @param {string} data.SpecId - The ID of the spec (if applicable).
     * @returns {Object} - An object containing the extracted listing information.
     */
    function getListingInfo(data) {
        return {
            communityId: data.CommunityId,
            isPlan: data.IsPlan,
            isMPCommunity: data.IsMPCommunity,
            planId: data.PlanId,
            specId: data.SpecId,
        };
    }

    /**
     * Returns the lead action string for requesting a free brochure.
     *
     * @returns {string} The action name 'RequestFreeBrochure'.
     */
    function getRequestFreeBrochureLeadAction() {
        return 'RequestFreeBrochure';
    }

    function bindEvents(data) {
        const recommendationsModal = document.querySelector('[data-recommendations-modal]');
        const submitButton = recommendationsModal.querySelector('[data-recommended-button]');

        (async function fetchBrochureUrl() {
            let pdfBrochureUrl = null;
            const listingInfo = getListingInfo(data);
            pdfBrochureUrl = await getPdfBrochureUrl(listingInfo, data.DisableBrochure);

            bindEventListenersAfterFetchBrochureUrl(
                pdfBrochureUrl,
                data,
                submitButton,
                skipButton
            );

            if (pdfBrochureUrl) {
                brochureBlobUrl = await window.NewHomeSource.BrochureHandler.getPdfBrochureBlob(pdfBrochureUrl);
            }
        })();


        const closeButton = recommendationsModal.querySelector('[data-modal-close-element]');
        closeButton.setAttribute('data-ga4-event-position', data.GenerateLeadFrom);
        closeButton.setAttribute('data-ga4-event-button_name', data.ButtonNameSource);

        const skipButton = recommendationsModal.querySelector('[data-skip-button]');
        skipButton.setAttribute('data-ga4-event-position', data.GenerateLeadFrom);
        skipButton.setAttribute('data-ga4-event-button_name', data.ButtonNameSource);

        // bind the data emmited by the event to the event handler.
        submitButton.setAttribute('data-ga4-event-position', data.GenerateLeadFrom);

        const recommendedElements = document.querySelectorAll('[data-recommendation-check]');
        recommendedElements.forEach((elem) => {
            elem.setAttribute('data-ga4-event-position', data.GenerateLeadFrom);
            elem.setAttribute('data-ga4-event-org_button_name', data.ButtonNameSource);
            elem.addEventListener('click', onRecommendationChecked.bind({ data }));
        });
    }

    /**
     * Handles the click event for the close button in the modal.
     * Reveals the modal background by removing the 'hidden' attribute,
     * and attempts to remove the 'hidden' attribute from the modal element.
     */
    function closeButtonClickHandler() {
        const modalBackground = document.querySelector('[data-modal-background]');
        const modal = document.getElementById('modal');
        document.activeElement.blur();

        if (modalBackground) {
            modalBackground.hidden = false;
        }

        if (modal) {
            modal.hidden = false;
        }
    }

    function bindEventListenersAfterFetchBrochureUrl(pdfBrochureUrl, data, submitButton, skipButton) {

        // Bind the submit button event listener
        skipButton.addEventListener('click', skipButtonClickHandler.bind({ data, pdfBrochureUrl }));

        // Bind the submit button event listener
        submitButton.addEventListener('click', submitButtonClickHandler.bind({ data, pdfBrochureUrl }));

        // Bind the close button event listener
        const closeButton = document.querySelector('[data-modal-close-element]');
        if (closeButton) {
            closeButton.addEventListener('click', closeButtonClickHandler);
        }

        // Select modal backgrounds, including both data-modal-background and data-modal-recommended-communities
        const modalBackgrounds = document.querySelectorAll("[data-modal-background], [data-modal-recommended-communities]");

        modalBackgrounds.forEach((background) => {
            background.addEventListener("click", function (event) {
                const modal = document.getElementById("nhs_ModalRecommendations");
                const thankYouModalElement = document.querySelector("[data-thank-you-modal-displayed]");
                const recommendationsModal = document.querySelector('[data-recommendations-modal]');
                const closeButton = recommendationsModal.querySelector('[data-modal-close-element]');
                const modalBg = document.getElementById('modal');

                // Open the PDF brochure if a click occurs outside the recommended communities modal.
                if (modal && !modal.contains(event.target) && thankYouModalElement.dataset.thankYouModalDisplayed === 'false') {
                    if (data.LeadAction === getRequestFreeBrochureLeadAction()) {
                        skipRecommendation(pdfBrochureUrl, data);
                    }
                    else {
                        closeButton.click();
                    }
                }
                else {
                    if (data.LeadAction !== getRequestFreeBrochureLeadAction()) {
                        closeButton.click();
                        if (modalBg) {
                            modalBg.removeAttribute('hidden');
                        }
                    }
                }
            });
        });
    }

    function modalHideEnableOnOutsideClick(leadActionBtn) {
        var recommendationModalElement = document.querySelector('[data-modal-recommended-communities]');
        if (leadActionBtn === getRequestFreeBrochureLeadAction()) {
            if (recommendationModalElement) {
                recommendationModalElement.removeAttribute('data-a11y-dialog-hide');
                recommendationModalElement.removeAttribute('data-modal-close-element');
            }
        } else {
            if (recommendationModalElement) {
                recommendationModalElement.setAttribute('data-a11y-dialog-hide', '');
                recommendationModalElement.setAttribute('data-modal-close-element', '');
            }
        }
    }

    document.addEventListener('openRecommendedModal', async (event) => {
        const data = event.detail.data;
        const isDisabled = String(data.DisableBrochure).toLowerCase() === 'true';

        leadActionBtn = isDisabled ? "" : data.LeadAction;
        lazyLoadCss();
        modalHideEnableOnOutsideClick(leadActionBtn);
        const recommended = await getRecommendedCommunities(data);
        showRecomendationsModal(recommended, data);

        bindEvents(data, event);
    });
}());
